module.exports = __webpack_public_path__ + "static/media/02-current.ecc8978a.png";